export default __webpack_public_path__ + "static/media/milestone 15.c36fe368.svg";